module.exports = __webpack_public_path__ + "static/media/gcdef_10015.54f2f602.ico";